var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page-layout',[_c('side-bar',{attrs:{"slot":"page_side_bar","side-options":_vm.mSideOption.options},on:{"click":_vm.onClickNav},slot:"page_side_bar"}),_c('router-view',{attrs:{"slot":"page_content"},slot:"page_content"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }